import { END_OF_TODAY, START_OF_TODAY } from "@/utils/dateUtils";
import {
  type AppointmentStatus,
  type AppointmentsSearchFilters,
  type WidgetSetting,
} from "@repo/api";
import { parseIsoDate } from "@repo/utils";
import { addDays, subDays } from "date-fns";

import { getCoworkerSettingsValue } from "../../customize/settings/CoworkerSettingsControl";

export const getAppointmentWidgetSettings = (
  settings?: WidgetSetting
): AppointmentsSearchFilters => {
  const { email, teamId, assignedToTeam } = getCoworkerSettingsValue(
    settings?.["COWORKER"]?.toString() ?? ""
  );

  const status = Array.isArray(settings?.status)
    ? (settings.status as AppointmentStatus[])
    : undefined;

  const dateRange = settings?.appointmentTimeRange as
    | {
        id: string;
        start: string | Date | undefined;
        end: string | Date | undefined;
      }
    | undefined;

  let appointmentDate: [Date, Date] = [START_OF_TODAY, END_OF_TODAY];

  if (dateRange?.id === "today") {
    appointmentDate = [START_OF_TODAY, END_OF_TODAY];
  }

  if (dateRange?.id === "yesterday") {
    appointmentDate = [subDays(START_OF_TODAY, 1), subDays(END_OF_TODAY, 1)];
  }

  if (dateRange?.id === "last_three_days") {
    appointmentDate = [subDays(START_OF_TODAY, 2), END_OF_TODAY];
  }

  if (dateRange?.id === "tomorrow") {
    appointmentDate = [addDays(START_OF_TODAY, 1), addDays(END_OF_TODAY, 1)];
  }

  if (dateRange?.id === "next_two_days") {
    appointmentDate = [START_OF_TODAY, addDays(END_OF_TODAY, 2)];
  }

  if (dateRange?.id === "custom_range") {
    appointmentDate = [
      dateRange.start ? parseIsoDate(dateRange.start)! : START_OF_TODAY,
      dateRange.end ? parseIsoDate(dateRange.end)! : END_OF_TODAY,
    ];
  }

  return {
    emailId: email,
    teamId,
    assignedToTeam,
    appointmentDate,
    status,
  };
};
